import { useDeviceMode } from '../../hooks/useDeviceMode';
import AdminLayout from '../layout/AdminLayout';
import AdminMobileLayout from './AdminMobileLayout';

export default function AdminAdaptiveLayout() {
  const { isMobile } = useDeviceMode();

  if (isMobile) {
    return <AdminMobileLayout />;
  }

  return <AdminLayout />;
}